module.exports = __webpack_public_path__ + "static/media/fly0098.4cd16ee5.webp";